<section class="outgoing-call-modal" aria-label="Outgoing call">
  <div class="outgoing-call-modal__halo" aria-hidden="true"></div>

  <header class="outgoing-call-modal__header">
    <p class="outgoing-call-modal__eyebrow">{{ getEyebrow() }}</p>
    <h2>{{ getTitle() }}</h2>
    <p class="outgoing-call-modal__subtitle">{{ getSubtitle() }}</p>
  </header>

  <div class="outgoing-call-modal__avatar" aria-hidden="true">
    @if (data.avatarUrl) {
      <img [src]="data.avatarUrl" [alt]="data.contactName" />
    } @else {
      <span>{{ data.initials }}</span>
    }
  </div>

  @if (state === 'pending') {
    <div class="outgoing-call-modal__dots" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </div>
  }

  <footer class="outgoing-call-modal__actions">
    @if (state === 'pending') {
      <button type="button" mat-stroked-button color="warn" (click)="cancel()">
        <mat-icon aria-hidden="true">call_end</mat-icon>
        Cancel Call
      </button>
    }

    @if (state === 'ready') {
      <button type="button" mat-flat-button color="primary" (click)="join()">
        <mat-icon aria-hidden="true">{{ data.mode === 'audio' ? 'call' : 'videocam' }}</mat-icon>
        Join Call
      </button>
    }

    @if (state === 'declined') {
      <button type="button" mat-stroked-button color="primary" (click)="close()">Close</button>
    }
  </footer>
</section>
